/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Category_EyebrowInputs */

const en_directory_taxonomy_index_category_eyebrow = /** @type {(inputs: Directory_Taxonomy_Index_Category_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sub-category directory`)
};

const zh_directory_taxonomy_index_category_eyebrow = /** @type {(inputs: Directory_Taxonomy_Index_Category_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`子分类目录`)
};

/**
* | output |
* | --- |
* | "Sub-category directory" |
*
* @param {Directory_Taxonomy_Index_Category_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_category_eyebrow = /** @type {((inputs?: Directory_Taxonomy_Index_Category_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Category_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_category_eyebrow(inputs)
	return zh_directory_taxonomy_index_category_eyebrow(inputs)
});
export { directory_taxonomy_index_category_eyebrow as "directory.taxonomy_index.category.eyebrow" }